import React from "react";
import "react-toastify/dist/ReactToastify.css";
import PageRoutes from "../../PageRoutes";
import { PageProps } from "../../types/Pages";

function MultiplePage({
  pages,
  storybook,
  renderers,
  lifecycleHooks,
  commonJsonHeaders,
  includeAdvancedRenderers,
}: PageProps) {
  return (
    <PageRoutes
      pages={pages}
      storybook={storybook}
      renderers={renderers}
      lifecycleHooks={lifecycleHooks}
      commonJsonHeaders={commonJsonHeaders}
      includeAdvancedRenderers={includeAdvancedRenderers}
    />
  );
}

export default MultiplePage;
